module.exports = __webpack_public_path__ + "img/c2.475cf067.png";